module.exports = __webpack_public_path__ + "img/chevron-up.c44bb046.svg";